// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2uqLg","calendarButtons":"ClockData_calendarButtons__1sKin"};